module.exports = __webpack_public_path__ + "bin/e3bc46e83b91440fbd21fb9f9d27c05a.svg";